<template>
  <div class="modal" id="modal-add-gift-vouchers" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-sm" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add a Gift Voucher</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form @submit.prevent="add">
          <div class="modal-body pb-0">

            <div class="form-group row">
              <label class="col-sm-3 pr-0 col-form-label required" for="input-gift-voucher-code">Code</label>
              <div class="col-sm-9">
                <input type="text" class="form-control" id="input-gift-voucher-code" name="code" v-model="code" minlength="4" maxlength="20" tabindex="1" required>
              </div>
            </div>

            <template v-if="giftVoucherCode">
              <div class="form-group row mb-0">
                <label class="col-sm-3 pr-0 col-form-label">Name</label>
                <div class="col-sm-9 col-form-label">
                  {{ giftVoucherCode.name }}
                </div>
              </div>

              <div class="form-group row mb-0">
                <div class="col-sm-9 offset-sm-3 col-form-label">
                  <span :class="'text-' + giftVoucherCode.active_status.class">
                    <i :class="giftVoucherCode.active_status.icon"></i>
                    {{ giftVoucherCode.active_status.name }}
                  </span>
                </div>
              </div>

              <div v-if="giftVoucherCode.valid_from" class="form-group row mb-0">
                <label class="col-sm-3 pr-0 col-form-label">From</label>
                <div class="col-sm-9 col-form-label">
                  {{ giftVoucherCode.valid_from | formatDate }}
                </div>
              </div>

              <div class="form-group row mb-0">
                <label class="col-sm-3 pr-0 col-form-label">Until</label>
                <div class="col-sm-9 col-form-label">
                  <template v-if="giftVoucherCode.valid_to">
                    {{ giftVoucherCode.valid_to | formatDate }}
                  </template>
                  <span v-else class="text-muted">
                    No expiry
                  </span>
                </div>
              </div>

              <div class="form-group row mb-0">
                <label class="col-sm-3 pr-0 col-form-label">Amount</label>
                <div class="col-sm-9 col-form-label">
                  {{ giftVoucherCode.total | numberToRs }}
                </div>
              </div>

              <div class="form-group row mb-0">
                <label class="col-sm-3 pr-0 col-form-label">Used</label>
                <div class="col-sm-9 col-form-label">
                  {{ giftVoucherCode.used | numberToRs }}
                </div>
              </div>

              <div class="form-group row mb-0 font-weight-bold">
                <label class="col-sm-3 pr-0 col-form-label">Balance</label>
                <div class="col-sm-9 col-form-label">
                  {{ giftVoucherCode.balance | numberToRs }}
                </div>
              </div>

              <div class="form-group row">
                <div class="col-sm-9 offset-sm-3 col-form-label">
                  <span :class="'text-' + giftVoucherCode.usage_status.class">
                    <i :class="giftVoucherCode.usage_status.icon"></i>
                    {{ giftVoucherCode.usage_status.name }}
                  </span>
                </div>
              </div>
            </template>

          </div>
          <div class="modal-footer">
            <button type="button" data-dismiss="modal" class="btn btn-outline-secondary">Close</button>
            <button type="button" class="btn btn-outline-primary" :disabled="!code || processing" @click.prevent="search">
              <i v-if="searching" class="fas fa-circle-notch fa-spin"></i>
              Search
            </button>
            <button type="submit" class="btn btn-primary" :disabled="!code || processing">
              <i v-if="adding" class="fas fa-circle-notch fa-spin"></i>
              Add
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import jQuery from 'jquery'

export default {
  name: 'GiftVouchers',
  data () {
    return {
      searching: false,
      adding: false,
      code: null,
      giftVoucherCode: null
    }
  },
  computed: {
    processing () {
      return this.searching || this.adding
    }
  },
  watch: {
    code () {
      this.giftVoucherCode = null
    }
  },
  methods: {
    async search () {
      if (!this.code) {
        this.$toast.error('Please provide the gift voucher code')
        return
      }

      this.searching = true

      await axios.get(process.env.URLS_POS_API + '/gift_vouchers/' + this.code).then((response) => {
        this.giftVoucherCode = response.data.data
      }).catch(error => {
        this.$toast.error('Failed to find the gift voucher.' + typeof error.response !== 'undefined' && typeof error.response.data.message !== 'undefined' ? error.response.data.message : null)
      }).finally(() => {
        this.searching = false
      })
    },
    add () {
      if (!this.code) {
        this.$toast.error('Please provide the gift voucher code')
        return
      }

      let postData = {
        code: this.code,
        include_cart: true
      }

      this.adding = true

      axios.post(process.env.URLS_PUBLIC_API + '/cart/' + this.$parent.cart.id + '/gift_vouchers', postData).then((response) => {
        this.$parent.cart = response.data.data.cart

        this.code = null
        this.giftVoucherCode = null

        jQuery('#modal-add-gift-vouchers').modal('hide')

        setTimeout(() => {
          this.$parent.setPaneHeights()
        }, 100)
      }).catch(error => {
        this.$toast.error('Failed to add the gift voucher.' + typeof error.response !== 'undefined' && typeof error.response.data.message !== 'undefined' ? error.response.data.message : null)
      }).finally(() => {
        this.adding = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sale/partials/GiftVoucherCodes.vue